import * as React from "react";
import { IGroup } from "./validators";

export const GroupsContext = React.createContext<IGroup[] | undefined>(
  undefined,
);

export function useGroups() {
  const value = React.useContext(GroupsContext);

  if (value === null) {
    throw new Error("`Missing GroupsContext` in tree.");
  }

  return value;
}
